"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notImplemented = function (fnname) { return function () {
    throw new Error(fnname + "(): No coreservices implementation for UI-Router is loaded.");
}; };
var services = {
    $q: undefined,
    $injector: undefined,
};
exports.services = services;
//# sourceMappingURL=coreservices.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uirouter/core/lib/common/coreservices.js
// module id = 20
// module chunks = 0